import classNames from "classnames";
import { Editor } from "primereact/editor";
import { KeyboardEventHandler } from "react";
import { Controller, FieldValues } from "react-hook-form";

import { FormControllerProp } from "../form-controller-prop.interface";
import FormError from "../form-error/form-error";

export type EditorControlType = "text" | "digit" | "password";
interface EditorControlProps<FieldsType extends FieldValues>
  extends FormControllerProp<FieldsType> {
  label?: string;
  placeholder?: string;
  className?: string;
  containerClassName?: string;
  type?: EditorControlType;
  disabled?: boolean;
  hint?: string;
  iconRight?: string;
  iconRightAction?: () => void;
  onKeyDown?: KeyboardEventHandler<HTMLInputElement> | undefined;
}

export function EditorControl<FieldsType extends FieldValues>({
  rules,
  label,
  control,
  name,
  placeholder,
  className,
  containerClassName,
  disabled,
  hint,
  iconRight,
  iconRightAction,
  onKeyDown,
}: EditorControlProps<FieldsType>) {
  const iconRightClass = iconRight ? "p-input-icon-right w-full" : "";
  const iconRightElement = iconRight ? (
    <i
      className={classNames(
        "pi",
        iconRight,
        iconRightAction ? "cursor-pointer pl-4" : ""
      )}
      onClick={() => {
        if (!iconRightAction) {
          return;
        }

        iconRightAction();
      }}
    />
  ) : null;

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState }) => (
        <div className={classNames("field mt-5", containerClassName)}>
            <label className="text-xs text-gray-500" htmlFor={field.name}>
              {label}
            </label>
          <span className={classNames("p-float-label", iconRightClass)}>
            {iconRightElement}
            <Editor
              id={field.name}
              value={field.value}
              placeholder={placeholder}
              className={classNames(
                { "p-invalid": fieldState.error },
                className,
                iconRight ? "pl-10" : ""
              )}
              onTextChange={(e) => field.onChange(e.htmlValue)} style={{ height: '320px' }}
              disabled={disabled}
              onKeyDown={onKeyDown}
            />
          </span>
          {hint && <small className="text-gray-400 mb-1">{hint}</small>}
          {fieldState.error && <FormError error={fieldState.error} />}
        </div>
      )}
    />
  );
}

export default EditorControl;
